<div class="container-fluid">
  <div class="row">
    <div class="qd-chat">
      <!-- ══ SIDEBAR ══════════════════════════════════════════════════════ -->
               <aside class="sidebar" [class.sidebar-open]="sidebarOpen" [class.mobile-chat-active]="showMobileChat">

        <!-- Header -->
        <div class="sidebar-header">
          <div class="my-profile">
            <div class="avatar avatar-md" [style.background]="color(me)">
              {{ initials(myName) }}
            </div>
            <div class="my-info">
              <span class="my-name">{{ myName }}</span>
              <span class="my-status"><span class="status-dot online"></span> Active</span>
            </div>
          </div>
          <div class="header-actions">
            <button class="action-btn" (click)="loadUsers(); loadRooms()" title="Refresh">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 4v6h-6" />
                <path d="M1 20v-6h6" />
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Search (private tab only) -->
        <div class="search-wrap" *ngIf="activeTab === 'private'">
          <div class="search-box">
            <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input type="text" class="search-input" [(ngModel)]="searchQuery" (input)="onSearchChange()"
              placeholder="Search people..." />
            <button class="search-clear" *ngIf="searchQuery" (click)="searchQuery = ''; onSearchChange()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Tabs -->
        <div class="tab-bar">
          <button class="tab-pill" [class.active]="activeTab === 'private'" (click)="setTab('private')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Chats
          </button>
          <button class="tab-pill" [class.active]="activeTab === 'group'" (click)="setTab('group')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            Groups
          </button>
        </div>

        <!-- ── Private: User List ────────────────────────────────────── -->
        <div class="list-wrap" *ngIf="activeTab === 'private'">
          <ng-container *ngIf="loadingUsers && users.length === 0">
            <div class="skeleton-row" *ngFor="let i of [1, 2, 3, 4, 5]">
              <div class="skeleton-av"></div>
              <div class="skeleton-lines">
                <div class="skeleton-line" style="width: 60%"></div>
                <div class="skeleton-line" style="width: 40%"></div>
              </div>
            </div>
          </ng-container>

          <div class="list-empty" *ngIf="!loadingUsers && filteredUsers.length === 0">
            <div class="empty-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <p>No users found</p>
          </div>

          <div *ngFor="let u of filteredUsers" class="conv-row" [class.active]="selectedUser?.userId === u.userId"
            (click)="selectUser(u)">
            <div class="conv-avatar-wrap">
              <div class="avatar avatar-md" [style.background]="color(u.userId)">
                {{ initials(u.displayName) }}
              </div>
              <span class="presence-dot" [class.online]="u.online"></span>
            </div>
            <div class="conv-info">
              <div class="conv-top">
                <span class="conv-name">{{ u.displayName }}</span>
                <span class="conv-time" *ngIf="u.lastTime">{{
                  fmt(u.lastTime)
                  }}</span>
              </div>
              <div class="conv-bottom">
                <span class="conv-preview" *ngIf="u.lastMessage">{{
                  u.lastMessage
                  }}</span>
                <span class="conv-preview muted" *ngIf="!u.lastMessage">Tap to chat</span>
                <span class="unread-badge" *ngIf="(u.unreadCount || 0) > 0">{{
                  u.unreadCount
                  }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Group: Room List ──────────────────────────────────────── -->
        <div class="list-wrap" *ngIf="activeTab === 'group'">
          <div class="group-search-container">
            <!-- Search input bar -->
            <div class="group-search-bar" [class.focused]="showGroupSuggestions || groupSearchQuery">
              <div class="group-search-icon">
                <!-- Spinner while searching -->
                <svg *ngIf="searchingGroups" class="search-spinner" width="16" height="16" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <!-- Static search icon -->
                <svg *ngIf="!searchingGroups" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
              </div>

              <input #groupSearchInput type="text" class="group-search-input" [value]="groupSearchQuery"
                (input)="onGroupSearchInput($any($event.target).value)" (keydown)="onGroupSearchKeydown($event)"
                (focus)="
                  groupSearchQuery &&
                    (showGroupSuggestions = groupSuggestions.length > 0)
                " placeholder="Search or discover groups…" autocomplete="off" />

              <!-- Clear button -->
              <button class="group-search-clear" *ngIf="groupSearchQuery"
                (click)="clearGroupSearch(); applyRoomSearch()" title="Clear search">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round">
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- ── Suggestions Dropdown ──────────────────────── -->
            <div class="group-suggestions-dropdown" *ngIf="
                showGroupSuggestions &&
                (groupSuggestions.length > 0 || groupSearchEmpty)
              ">
              <!-- Result header -->
              <div class="suggestions-header" *ngIf="groupSuggestions.length > 0">
                <span class="suggestions-label">
                  {{ groupSuggestions.length }} group{{
                  groupSuggestions.length !== 1 ? "s" : ""
                  }}
                  found
                </span>
                <span class="suggestions-hint">↑↓ to navigate · Enter to select · Esc to dismiss</span>
              </div>

              <!-- Empty state -->
              <div class="suggestions-empty" *ngIf="groupSearchEmpty">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"
                  stroke-linecap="round" opacity="0.35">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <p>
                  No groups match <strong>"{{ groupSearchQuery }}"</strong>
                </p>
                <small>Try a different name or create a new group</small>
              </div>

              <!-- Suggestion rows -->
              <div *ngFor="let sg of groupSuggestions; let i = index" class="suggestion-row"
                [class.suggestion-active]="isSuggestionActive(i)"
                (mouseenter)="activeSuggestionIndex = i; hoveredSuggestion = sg" (mouseleave)="hoveredSuggestion = null"
                (click)="selectSuggestion(sg)">
                <!-- Avatar -->
                <div class="suggestion-avatar" [style.background]="color(sg.roomId)">
                  {{ (sg.roomName.charAt(0) || "?").toUpperCase() }}
                </div>

                <!-- Info column -->
                <div class="suggestion-info">
                  <!-- Room name with match highlight -->
                  <div class="suggestion-name">
                    <ng-container *ngIf="
                        highlightMatch(sg.roomName, groupSearchQuery) as hl
                      ">
                      <span>{{ hl.before }}</span>
                      <mark class="match-highlight" *ngIf="hl.match">{{
                        hl.match
                        }}</mark>
                      <span>{{ hl.after }}</span>
                    </ng-container>
                  </div>

                  <!-- Meta row: member count + room id -->
                  <div class="suggestion-meta">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" style="flex-shrink: 0">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <span>{{ memberCountLabel(sg.memberCount) }}</span>
                    <span class="meta-sep">·</span>
                    <span class="meta-id">{{ sg.roomId }}</span>
                  </div>
                </div>

                <!-- Right: badge + action hint -->
                <div class="suggestion-right">
                  <span class="suggestion-badge joined" *ngIf="sg.isJoined">Joined</span>
                  <span class="suggestion-badge discover" *ngIf="!sg.isJoined">Join</span>

                  <!-- Chevron on active row -->
                  <svg class="suggestion-chevron" *ngIf="isSuggestionActive(i)" width="14" height="14"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </div>
              </div>

              <!-- Footer hint -->
              <div class="suggestions-footer" *ngIf="groupSuggestions.length > 0">
                <span>Can't find it? </span>
                <button class="suggestions-create-link" (click)="showCreate = true; showGroupSuggestions = false">
                  Create a new group
                </button>
              </div>
            </div>
          </div>
          <div class="group-actions">
            <button class="group-action-btn" (click)="
                showCreate ? closeCreateForm() : (showCreate = true);
                showJoin = false
              ">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round">
                <path d="M12 5v14M5 12h14" />
              </svg>
              New Group
            </button>
            <button class="group-action-btn secondary" (click)="showJoin = !showJoin; showCreate = false">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
              Join
            </button>
          </div>

          <!-- <div class="mini-form" *ngIf="showCreate">
                              <input class="mini-input" [(ngModel)]="newRoomId" placeholder="group-id (no spaces)" />
                              <input class="mini-input" [(ngModel)]="newRoomName" placeholder="Display name" />
                              <div class="mini-form-actions">
                                   <button class="mini-btn cancel" (click)="showCreate=false">Cancel</button>
                                   <button class="mini-btn confirm" (click)="createRoom()"
                                        [disabled]="!newRoomId.trim()">Create</button>
                              </div>
                         </div> -->
          <!-- ── Create Group form ──────────────────────────────────────────── -->
          <div class="mini-form" *ngIf="showCreate">
            <input class="mini-input" [(ngModel)]="newRoomId" placeholder="group-id (letters, numbers, hyphens)"
              (input)="createRoomError = ''" autocomplete="off" />

            <input class="mini-input" [(ngModel)]="newRoomName" placeholder="Display name"
              (input)="createRoomError = ''" autocomplete="off" />

            <!-- Inline validation error ──────────────────────────────────── -->
            <div class="mini-form-error" *ngIf="createRoomError">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ createRoomError }}
            </div>

            <div class="mini-form-actions">
              <button class="mini-btn cancel" (click)="closeCreateForm()">
                Cancel
              </button>
              <button class="mini-btn confirm" (click)="createRoom()" [disabled]="!newRoomId.trim()">
                Create
              </button>
            </div>
          </div>

          <!-- <div class="mini-form" *ngIf="showJoin">
                              <input class="mini-input" [(ngModel)]="joinRoomId" placeholder="Enter room-id" />
                              <div class="mini-form-actions">
                                   <button class="mini-btn cancel" (click)="showJoin=false">Cancel</button>
                                   <button class="mini-btn confirm" (click)="joinRoom()"
                                        [disabled]="!joinRoomId.trim()">Join</button>
                              </div>
                         </div> -->
          <div class="mini-form" *ngIf="showJoin">
            <input class="mini-input" [(ngModel)]="joinRoomInput" placeholder="Enter group ID or name" />

            <div class="mini-form-error" *ngIf="joinRoomError">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ joinRoomError }}
            </div>

            <div class="mini-form-actions">
              <button class="mini-btn cancel" (click)="
                  showJoin = false; joinRoomInput = ''; joinRoomError = ''
                ">
                Cancel
              </button>
              <button class="mini-btn confirm" (click)="joinRoom()" [disabled]="!joinRoomInput.trim() || joiningRoom">
                <span *ngIf="joiningRoom" class="spinner-border spinner-border-sm me-1"
                  style="width: 12px; height: 12px"></span>
                {{ joiningRoom ? "Joining…" : "Join" }}
              </button>
            </div>
          </div>
          <ng-container *ngIf="loadingRooms && rooms.length === 0">
            <div class="skeleton-row" *ngFor="let i of [1, 2, 3]">
              <div class="skeleton-av"></div>
              <div class="skeleton-lines">
                <div class="skeleton-line" style="width: 55%"></div>
                <div class="skeleton-line" style="width: 35%"></div>
              </div>
            </div>
          </ng-container>

          <div class="list-empty" *ngIf="!loadingRooms && filteredRooms.length === 0">
            <div class="empty-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <p>No groups yet<br /><small>Create or join a group</small></p>
          </div>

          <!-- No local results while searching -->
          <div class="list-search-hint" *ngIf="
              groupSearchQuery &&
              filteredRooms.length === 0 &&
              !showGroupSuggestions
            ">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" opacity="0.4">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <span>No joined groups match "{{ groupSearchQuery }}"</span>
          </div>

          <!-- Group list (filtered by search) -->
          <div *ngFor="let r of filteredRooms" class="conv-row" [class.active]="selectedRoom?.roomId === r.roomId"
            (click)="selectRoom(r)">
            <div class="conv-avatar-wrap">
              <div class="avatar avatar-md group-av" [style.background]="color(r.roomId)">
                {{ (r.roomName.charAt(0) || "?").toUpperCase() }}
              </div>
            </div>
            <div class="conv-info">
              <div class="conv-top">
                <!-- Highlight matched portion of room name -->
                <span class="conv-name">
                  <ng-container *ngIf="groupSearchQuery; else plainName">
                    <ng-container *ngIf="highlightMatch(r.roomName, groupSearchQuery) as hl">
                      <span>{{ hl.before }}</span>
                      <mark class="list-match-highlight" *ngIf="hl.match">{{
                        hl.match
                        }}</mark>
                      <span>{{ hl.after }}</span>
                    </ng-container>
                  </ng-container>
                  <ng-template #plainName>{{ r.roomName }}</ng-template>
                </span>
                <span class="conv-time" *ngIf="r.lastTime">{{
                  fmt(r.lastTime)
                  }}</span>
              </div>
              <div class="conv-bottom">
                <!-- <span class="conv-preview" *ngIf="r.lastMessage">{{ r.lastMessage }}</span>
                                        <span class="conv-preview muted" *ngIf="!r.lastMessage">{{
                                             (r.memberUserIds?.length||0) }} members</span> -->
                <span class="conv-preview" *ngIf="r.lastMessage">{{
                  r.lastMessage
                  }}</span>
                <!-- ── NEW: show member names in sidebar row when no last message ── -->
                <span class="conv-preview muted members-preview" *ngIf="!r.lastMessage" [title]="fullMemberList(r)">
                  {{ formatMemberList(r) }}
                </span>
                <span class="unread-badge" *ngIf="(r.unreadCount || 0) > 0">{{
                  r.unreadCount
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <!-- Sidebar backdrop (mobile) -->
               <div class="sidebar-backdrop" [class.visible]="sidebarOpen"
                    (click)="showMobileChat ? (sidebarOpen=false) : (sidebarOpen=false)"></div>

      <!-- ══ MAIN CHAT AREA ══════════════════════════════════════════════ -->
      <main class="chat-area">

                    <!-- Mobile header for welcome/no-chat state -->
                    <div class="mobile-welcome-bar" *ngIf="!selectedUser && !selectedRoom">
                         <button class="hamburger-btn" (click)="sidebarOpen=!sidebarOpen" title="Chats">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round">
                                   <line x1="3" y1="6" x2="21" y2="6" />
                                   <line x1="3" y1="12" x2="21" y2="12" />
                                   <line x1="3" y1="18" x2="21" y2="18" />
                              </svg>
                         </button>
                         <span class="mobile-welcome-title">CuickDev Chat</span>
                    </div>

        <!-- Welcome screen -->
        <div class="chat-welcome" *ngIf="!selectedUser && !selectedRoom">
          <div class="welcome-inner">
            <div class="welcome-logo">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"
                stroke-linecap="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <h2 class="welcome-title">CuickDev Chat</h2>
            <p class="welcome-sub">Select a conversation to start messaging</p>
            <div class="welcome-features">
              <div class="feature-pill">
                <span class="feature-dot"></span> Real-time messaging
              </div>
              <div class="feature-pill">
                <span class="feature-dot"></span> Group channels
              </div>
              <div class="feature-pill">
                <span class="feature-dot"></span> Seen receipts
              </div>
            </div>
          </div>
        </div>

        <!-- Active conversation -->
        <ng-container *ngIf="selectedUser || selectedRoom">
          <!-- Header -->
          <div class="conv-header">

                              <!-- Mobile back button -->
                              <button class="hamburger-btn back-btn" (click)="goBackToSidebar()" title="Back to chats">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>

            <div class="conv-header-info">
              <ng-container *ngIf="selectedUser">
                <div class="avatar avatar-sm" [style.background]="color(selectedUser.userId)">
                  {{ initials(selectedUser.displayName) }}
                </div>
                <div class="conv-header-text">
                  <span class="conv-header-name">{{
                    selectedUser.displayName
                    }}</span>
                  <span class="conv-header-sub">
                    <span class="status-dot" [class.online]="selectedUser.online"></span>
                    {{ selectedUser.online ? "Online" : "Last seen recently" }}
                  </span>
                </div>
              </ng-container>

              <ng-container *ngIf="selectedRoom">
                <div class="avatar avatar-sm group-av" [style.background]="color(selectedRoom.roomId)">
                  {{ initials(selectedRoom.roomName) }}
                </div>
                <div class="conv-header-text">
                  <span class="conv-header-name">{{
                    selectedRoom.roomName
                    }}</span>
                  <!-- <span class="conv-header-sub">
                                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                                       stroke="currentColor" stroke-width="2" stroke-linecap="round"> -->
                  <span class="conv-header-sub members-sub" [title]="fullMemberList(selectedRoom)">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" style="flex-shrink: 0">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <!-- {{ (selectedRoom.memberUserIds?.length||0) }} members -->
                    <span class="members-text">{{
                      formatMemberList(selectedRoom)
                      }}</span>
                  </span>
                </div>
              </ng-container>
            </div>
            <div class="conv-header-actions">
              <!-- Members panel toggle — group only -->
              <button class="header-action-btn" *ngIf="selectedRoom" (click)="toggleMembersPanel()" title="Members"
                [style.background]="
                  showMembersPanel ? 'rgba(255,255,255,0.25)' : ''
                ">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </button>
              <!-- Search toggle -->
              <button class="header-action-btn" (click)="toggleSearchBox()" title="Search in conversation">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
              </button>

              <!-- Search bar (shown when searchActive) -->
              <div class="msg-search-wrap" *ngIf="searchActive">
                <input type="text" class="msg-search-input" [(ngModel)]="searchMsgQuery"
                  placeholder="Search in conversation..." autofocus />
                <button class="msg-search-nav" *ngIf="searchMsgQuery && matchesList.length" (click)="prevMatch()"
                  title="Previous">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M15 18l-6-6 6-6" stroke-width="2" />
                  </svg>
                </button>
                <button class="msg-search-nav" *ngIf="searchMsgQuery && matchesList.length" (click)="nextMatch()"
                  title="Next">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M9 18l6-6-6-6" stroke-width="2" />
                  </svg>
                </button>
                <span class="msg-search-count" *ngIf="searchMsgQuery && matchesList.length">
                  {{ currentMatchIndex + 1 }}/{{ matchesList.length }}
                </span>
              </div>
            </div>
          </div>

          <!-- ── Messages area ─────────────────────────────────────────── -->
          <div class="messages-area" #msgBox>
            <div class="msgs-loading" *ngIf="loadingMsgs">
              <div class="loading-dots">
                <span></span><span></span><span></span>
              </div>
            </div>

            <div class="msgs-empty" *ngIf="!loadingMsgs && messages.length === 0">
              <div class="empty-bubble">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <p>No messages yet</p>
                <small>Send a message to get started</small>
              </div>
            </div>

            <ng-container *ngFor="let m of messages; let i = index">
              <!-- Date divider -->
              <div class="date-divider" *ngIf="isNewDay(i)">
                <span>{{ getDateLabel(m.timestamp) }}</span>
              </div>
              <!-- ── SYSTEM MESSAGE (member added / left group) ── -->
              <div *ngIf="m.isSystemMessage || m.type === 'SYSTEM'"
                class="d-flex justify-content-center align-items-center my-2">
                <span class="badge rounded-pill bg-light text-secondary border px-3 py-2 small fw-normal shadow-sm">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" class="me-1 opacity-75">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  {{ m.content }}
                </span>
              </div>
              <!-- Message wrapper -->
                                   <!-- <div class="msg-wrapper" [class.mine]="isMine(m)" [class.theirs]="!isMine(m)"
                                        *ngIf="!m.isSystemMessage && m.type !== 'SYSTEM'"
                                        (mouseenter)="hoveredMsgId = msgKey(m)" (mouseleave)="hoveredMsgId = null"> -->

              <div class="msg-wrapper" #msgWrapper [class.mine]="isMine(m)" [class.theirs]="!isMine(m)"
                [class.search-match]="isSearchMatch(m)" [attr.data-msg-id]="msgKey(m)"
                [class.current-match]="isCurrentMatch(i)" *ngIf="!m.isSystemMessage && m.type !== 'SYSTEM'"
                                        (mouseenter)="hoveredMsgId = msgKey(m)" (mouseleave)="hoveredMsgId = null">


                <!-- Group: sender avatar (theirs only) -->
                <div class="avatar avatar-xs msg-avatar" *ngIf="selectedRoom && !isMine(m)"
                  [style.background]="color(m.fromEmailId)">
                  {{ initials(senderName(m)) }}
                </div>

                <div class="bubble-col">
                  <!-- Group: sender name -->
                  <span class="bubble-sender" *ngIf="selectedRoom && !isMine(m)">{{ senderName(m) }}</span>

                  <div class="bubble" [class.mine]="isMine(m)" [class.theirs]="!isMine(m)">
                    <!-- ── Reply-quote block (shown when message was a reply) ── -->
                    <div class="reply-quote" *ngIf="m.replyTo" (click)="scrollToOriginal(m.replyTo)">
                      <span class="reply-quote-author">{{
                        replyAuthorLabel(m.replyTo)
                        }}</span>
                      <span class="reply-quote-text" *ngIf="m.replyTo.content">{{ m.replyTo.content }}</span>
                      <span class="reply-quote-file" *ngIf="!m.replyTo.content && m.replyTo.fileOriginalName">
                        📎 {{ m.replyTo.fileOriginalName }}
                      </span>
                    </div>

                    <!-- ── Text content (shown when there is text) ─── -->
                    <span class="bubble-text" *ngIf="m.content">{{
                      m.content
                      }}</span>

                    <!-- ════════════════════════════════════════════════
                         FILE / IMAGE ATTACHMENT
                         Condition: message has imageId (new path via doc
                         service) OR legacy fileUrl
                    ═════════════════════════════════════════════════ -->
                    <ng-container *ngIf="hasFile(m)">
                      <!-- ── IMAGE ──────────────────────────────────── -->
                      <ng-container *ngIf="isImageFile(m)">
                        <div class="file-image-wrap" (click)="openFile(m)">
                          <!-- getDocUrl uses DOC_API + 'th/' + imageId + '?t=' -->
                          <img *ngIf="m.imageId" [src]="getDocUrl(m.imageId)" [alt]="m.fileOriginalName || 'Image'"
                            class="bubble-image" (error)="imgErr($event)" />
                          <!-- Legacy fileUrl fallback -->
                          <img *ngIf="!m.imageId && m.fileUrl" [src]="resolveFileUrl(m)"
                            [alt]="m.fileOriginalName || 'Image'" class="bubble-image" (error)="imgErr($event)" />
                          <!-- Zoom icon overlay -->
                          <div class="image-overlay">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                              stroke-linecap="round">
                              <circle cx="11" cy="11" r="8" />
                              <path d="m21 21-4.35-4.35" />
                              <path d="M11 8v6M8 11h6" />
                            </svg>
                          </div>
                        </div>
                        <!-- Filename caption below image (optional) -->
                        <div class="image-caption" *ngIf="m.fileOriginalName">
                          {{ m.fileOriginalName }}
                        </div>
                      </ng-container>

                      <!-- ── DOCUMENT / PDF / CSV / OTHER ───────────── -->
                      <ng-container *ngIf="!isImageFile(m)">
                        <div class="file-doc-card" (click)="openFile(m)">
                          <!-- Icon box with file type label -->
                          <div class="file-doc-icon" [style.background]="fileIconColor(m.fileType)">
                            <span>{{ getFileExt(m) }}</span>
                          </div>
                          <!-- File info -->
                          <div class="file-doc-info">
                            <div class="file-doc-name">
                              {{ m.fileOriginalName || "File" }}
                            </div>
                            <div class="file-doc-meta">
                              {{ m.fileType }}
                              <ng-container *ngIf="m.fileSize">
                                · {{ formatFileSize(m.fileSize) }}</ng-container>
                              <span class="file-doc-action">
                                · Tap to open</span>
                            </div>
                          </div>
                          <!-- Download arrow icon -->
                          <div class="file-doc-dl">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9E9E9E"
                              stroke-width="2" stroke-linecap="round">
                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                              <polyline points="7 10 12 15 17 10" />
                              <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                    <!-- ── END FILE ATTACHMENT ── -->

                    <!-- Bubble footer: time + ticks -->
                    <div class="bubble-footer">
                      <span class="bubble-time">{{ fmt(m.timestamp) }}</span>

                      <!-- Private chat: delivery ticks -->
                      <span class="bubble-ticks" *ngIf="isMine(m) && !selectedRoom">
                        <!-- SENT: single grey tick -->
                        <ng-container *ngIf="!m.status || m.status === 'SENT'">
                          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" class="tick" title="Sent">
                            <path d="M1.5 5L4.5 8.5L12.5 1" stroke="#8696A0" stroke-width="1.8" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </ng-container>
                        <!-- DELIVERED: double grey tick -->
                        <ng-container *ngIf="m.status === 'DELIVERED'">
                          <svg width="19" height="10" viewBox="0 0 19 10" fill="none" class="tick" title="Delivered">
                            <path d="M1 5L4 8.5L12 1" stroke="#8696A0" stroke-width="1.8" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M6 5L9 8.5L17 1" stroke="#8696A0" stroke-width="1.8" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </ng-container>
                        <!-- SEEN: double blue tick -->
                        <ng-container *ngIf="m.status === 'SEEN'">
                          <svg width="19" height="10" viewBox="0 0 19 10" fill="none" class="tick tick-seen"
                            title="Seen">
                            <path d="M1 5L4 8.5L12 1" stroke="#53BDEB" stroke-width="1.8" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M6 5L9 8.5L17 1" stroke="#53BDEB" stroke-width="1.8" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </ng-container>
                      </span>

                      <!-- Group chat: double grey tick always -->
                      <span class="bubble-ticks" *ngIf="isMine(m) && selectedRoom">
                        <svg width="19" height="10" viewBox="0 0 19 10" fill="none" class="tick">
                          <path d="M1 5L4 8.5L12 1" stroke="#8696A0" stroke-width="1.8" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M6 5L9 8.5L17 1" stroke="#8696A0" stroke-width="1.8" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <!-- /bubble -->

                  <!-- Reply action button — visible on hover -->
                  <div class="msg-actions" [class.visible]="hoveredMsgId === msgKey(m)">
                    <button class="msg-action-btn reply-btn" (click)="startReply(m)" title="Reply">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 17 4 12 9 7" />
                        <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
                      </svg>
                    </button>
                  </div>
                </div>
                <!-- /bubble-col -->
              </div>
              <!-- /msg-wrapper -->
            </ng-container>
          </div>
          <!-- /messages-area -->
          <!-- File attachment error -->
          <div class="file-attach-error" *ngIf="pendingFileError">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            {{ pendingFileError }}
            <button (click)="pendingFileError = null">✕</button>
          </div>

          <!-- Pending file preview (Teams-style) -->
          <div class="file-attach-preview" *ngIf="pendingFile">
            <div class="attach-preview-inner">
              <div class="attach-image-thumb" *ngIf="pendingFilePreviewUrl; else fileIcon">
                <img [src]="pendingFilePreviewUrl" alt="preview" style="
                    height: 48px;
                    width: 48px;
                    object-fit: cover;
                    border-radius: 6px;
                  " />
              </div>
              <!-- Generic file icon (non-image files) -->
              <ng-template #fileIcon>
                <div class="attach-icon" [style.background]="
                    fileIconColor(
                      pendingFile!.name.split('.').pop()?.toUpperCase()
                    )
                  ">
                  {{
                  (pendingFile!.name.split(".").pop() || "FILE")
                  .toUpperCase()
                  .substring(0, 4)
                  }}
                </div>
              </ng-template>
              <div class="attach-info">
                <span class="attach-name">{{ pendingFile.name }}</span>
                <span class="attach-size">{{
                  formatFileSize(pendingFile.size)
                  }}</span>
              </div>
              <button class="attach-remove" (click)="clearPendingFile()" title="Remove">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round">
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <!-- Reply preview bar (appears above input when replying) -->
          <div class="reply-preview-bar" *ngIf="replyingTo">
            <div class="reply-preview-inner">
              <div class="reply-preview-accent"></div>
              <div class="reply-preview-text">
                <span class="reply-preview-author">{{
                  replyAuthorLabel(replyingTo)
                  }}</span>
                <span class="reply-preview-content" *ngIf="replyingTo.content">{{ replyingTo.content | slice: 0 : 100
                  }}</span>
                <span class="reply-preview-content" *ngIf="!replyingTo.content && replyingTo.fileOriginalName">📎 {{
                  replyingTo.fileOriginalName }}</span>
              </div>
              <button class="reply-preview-close" (click)="cancelReply()" title="Cancel reply">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round">
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <!-- ── Input bar ──────────────────────────────────────────── -->
          <div class="input-bar">
            <div class="input-wrap" style="position: relative">
              <!-- Emoji button -->
              <!-- <button
                class="input-action emoji-btn"
                (click)="toggleEmojiPicker()"
                type="button"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                  <line x1="9" y1="9" x2="9.01" y2="9" />
                  <line x1="15" y1="9" x2="15.01" y2="9" />
                </svg>
              </button> -->

              <button class="input-action emoji-btn" (click)="toggleEmojiPicker()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path
                    d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24m0 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20M8 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-.8 8c-.7 1.2-1.8 2-3.3 2-1.5 0-2.7-.8-3.4-2H15m3-2H6a6 6 0 1 0 12 0">
                  </path>
                </svg>
              </button>

              <!-- Emoji picker -->
              <div class="emoji-picker-container" *ngIf="showEmojiPicker">
                <emoji-mart (emojiClick)="addEmoji($event)" [emojiSize]="22" [perLine]="9" [showPreview]="false"
                  [emojiTooltip]="false" [style]="{ width: '320px' }">
                </emoji-mart>
              </div>

              <!-- Text area -->
              <textarea class="msg-textarea" [(ngModel)]="newMessage" (keydown)="onEnter($event)"
                (input)="autoResize($event)" placeholder="Type a message" rows="1"></textarea>

              <!-- Hidden file input -->
              <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)"
                accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.csv,.txt,.xls,.xlsx" />

              <!-- Attach button -->
              <button class="input-action" title="Attach file" (click)="fileInput.click()" [disabled]="sending">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round">
                  <path
                    d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
              </button>

              <!-- Upload progress indicator -->
              <div class="upload-spinner" *ngIf="sending">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" class="spin-anim">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
              </div>
            </div>

            <!-- Send button -->
            <!-- Send button -->
            <button class="send-button" [class.has-text]="newMessage.trim() || pendingFile" (click)="sendMessage()"
              [disabled]="(!newMessage.trim() && !pendingFile) || sending">
              <!-- Mic icon when empty -->
              <svg *ngIf="!newMessage.trim() && !pendingFile" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
              </svg>
              <!-- Send icon when text or file present -->
              <svg *ngIf="newMessage.trim() || pendingFile" width="22" height="22" viewBox="0 0 24 24"
                fill="currentColor">
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
              </svg>
            </button>
          </div>
        </ng-container>
        <!-- ══ MEMBERS PANEL ══════════════════════════════════════════════ -->
        <!-- Members Popup -->
        <!-- <div class="members-popup" *ngIf="showMembersPanel && selectedRoom">
                    

                         <div class="members-popup-header">
                              <span>
                                   <span class="members-popup-title">Members</span>
                                   <span class="members-popup-count">({{ selectedRoom?.memberDetails?.length || 0
                                        }})</span>
                              </span>
                              <button class="members-popup-close" (click)="toggleMembersPanel()">
                                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2.5" stroke-linecap="round">
                                        <path d="M18 6 6 18M6 6l12 12" />
                                   </svg>
                              </button>
                         </div>

                         <div class="members-popup-search">
                              <div class="members-popup-search-box">
                                   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9e9e9e"
                                        stroke-width="2.5" stroke-linecap="round">
                                        <circle cx="11" cy="11" r="8" />
                                        <path d="m21 21-4.35-4.35" />
                                   </svg>
                                   <input type="text" [(ngModel)]="memberSearchQuery" placeholder="Search members..." />
                              </div>
                         </div>

                         <div class="members-popup-list">
                              <div class="members-empty" *ngIf="filteredPanelMembers.length === 0">No members found
                              </div>
                              <div *ngFor="let member of filteredPanelMembers" class="member-row">
                                   <div class="avatar avatar-sm" [style.background]="color(member.userId)">
                                        {{ initials(member.displayName) }}
                                   </div>
                                   <div class="member-info">
                                        <div class="member-name">{{ member.displayName }}</div>
                                        <div class="member-email">{{ member.userId }}</div>
                                   </div>
                                   <span class="member-badge you" *ngIf="member.userId === me">You</span>
                                   <span class="member-badge"
                                        *ngIf="member.userId === selectedRoom?.createdBy && member.userId !== me">Admin</span>
                              </div>
                         </div>
                         <div class="panel-add-row" (click)="openAddMemberModal(); showMembersPanel=false">
                              <div class="panel-add-icon">
                                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b5bdb"
                                        stroke-width="2.5" stroke-linecap="round">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <line x1="19" y1="8" x2="19" y2="14" />
                                        <line x1="22" y1="11" x2="16" y2="11" />
                                   </svg>
                              </div>
                              <span class="panel-add-text">Add people</span>
                         </div>
                    </div> -->
        <!-- ══ MEMBERS PANEL ══════════════════════════════════════════════ -->
        <div class="members-popup" *ngIf="showMembersPanel && selectedRoom" (click)="$event.stopPropagation()">
          <div class="panel-people-label">
            People ({{ selectedRoom.memberDetails?.length || 0 }})
          </div>

          <div class="members-popup-list">
            <div class="members-empty" *ngIf="filteredPanelMembers.length === 0">
              No members found
            </div>
            <div *ngFor="let member of filteredPanelMembers" class="member-row">
              <div class="avatar avatar-sm" [style.background]="color(member.userId)">
                {{ initials(member.displayName) }}
              </div>
              <div class="member-info">
                <div class="member-name">
                  {{ member.displayName }}
                  <span *ngIf="member.userId === me" class="you-badge-inline">
                    ( You )</span>
                </div>
                <div class="member-email">{{ member.userId }}</div>
              </div>
              <!-- <span class="member-badge you" *ngIf="member.userId === me">You</span> -->
            </div>
          </div>

          <div class="panel-add-row" (click)="showInlineAddMember = true; $event.stopPropagation()"
            *ngIf="!showInlineAddMember">
            <div class="panel-add-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b5bdb" stroke-width="2.5"
                stroke-linecap="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>
            </div>
            <span class="panel-add-text">Add people</span>
          </div>
          <!-- NEW: Leave group row -->
          <div class="panel-add-row leave-row" (click)="openLeaveGroupModal()" *ngIf="selectedRoom">
            <div class="panel-add-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2.5"
                stroke-linecap="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </div>
            <span class="panel-add-text" style="color: #dc3545">Leave group</span>
          </div>
        </div>

        <!-- ══ ADD MEMBER FLOATING PANEL (Teams style — alag popup) ══════ -->
        <div class="add-member-float-panel" *ngIf="showInlineAddMember && selectedRoom"
          (click)="$event.stopPropagation()">
          <!-- Title -->
          <div class="fw-semibold mb-3" style="font-size: 14px">Add</div>

          <!-- Search input -->
          <div class="position-relative mb-2">
            <input type="text" class="form-control form-control-sm panel-inline-input" [value]="addMemberSearchQuery"
              (input)="onAddMemberSearchInput($any($event.target).value)"
              placeholder="Enter name, email or phone number" autocomplete="off" />

            <!-- Suggestions dropdown -->
            <div class="panel-inline-suggestions" *ngIf="addMemberSuggestions.length > 0">
              <div *ngFor="let c of addMemberSuggestions"
                class="d-flex align-items-center gap-2 px-3 py-2 list-group-item list-group-item-action"
                style="cursor: pointer; font-size: 12px" (click)="selectAddMemberCandidate(c)">
                <div class="avatar avatar-sm flex-shrink-0" [style.background]="color(c.userId)">
                  {{ initials(c.displayName) }}
                </div>
                <div class="overflow-hidden">
                  <div class="fw-medium text-truncate">{{ c.displayName }}</div>
                  <div class="text-muted text-truncate" style="font-size: 11px">
                    {{ c.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected chip -->
          <div class="d-flex align-items-center gap-2 rounded px-2 py-1 mb-2 bg-white bg-opacity-10"
            *ngIf="selectedAddMemberUser">
            <div class="avatar avatar-sm flex-shrink-0" [style.background]="color(selectedAddMemberUser.userId)">
              {{ initials(selectedAddMemberUser.displayName) }}
            </div>
            <span class="flex-grow-1 text-truncate" style="font-size: 12px">
              {{ selectedAddMemberUser.displayName }}
            </span>
            <button class="btn btn-sm p-0 text-muted" (click)="selectedAddMemberUser = null; addMemberSearchQuery = ''">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Hint text -->
          <div class="text-muted mb-3" style="font-size: 11px">
            All chat history will be visible to new members.
          </div>

          <!-- Feedback -->
          <div class="alert alert-success py-1 px-2 mb-2" style="font-size: 11px"
            *ngIf="addMemberMessage && !addMemberError">
            ✓ {{ addMemberMessage }}
          </div>
          <div class="alert alert-danger py-1 px-2 mb-2" style="font-size: 11px"
            *ngIf="addMemberMessage && addMemberError">
            ✕ {{ addMemberMessage }}
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-sm btn-outline-secondary px-3" (click)="
                showInlineAddMember = false;
                addMemberSearchQuery = '';
                selectedAddMemberUser = null;
                addMemberMessage = ''
              ">
              Cancel
            </button>
            <button class="btn btn-sm btn-primary px-3 d-flex align-items-center gap-1" (click)="confirmAddMember()"
              [disabled]="!selectedAddMemberUser || addingMember">
              <span *ngIf="addingMember" class="spinner-border spinner-border-sm"></span>
              {{ addingMember ? "Adding…" : "Add" }}
            </button>
          </div>
        </div>
      </main>
      <div class="modal fade show d-block add-member-modal-backdrop" tabindex="-1" role="dialog"
        *ngIf="showAddMemberModal" (click)="closeAddMemberModal()">
        <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
          <div class="modal-content border-0 shadow">
            <!-- Modal Header -->
            <div class="modal-header border-bottom px-4 py-3">
              <div class="d-flex align-items-center gap-2">
                <div class="avatar avatar-sm group-av" [style.background]="color(selectedRoom?.roomId || '')">
                  {{ (selectedRoom?.roomName?.charAt(0) || "?").toUpperCase() }}
                </div>
                <div>
                  <h6 class="modal-title mb-0 fw-semibold">Add Member</h6>
                  <small class="text-muted">{{ selectedRoom?.roomName }}</small>
                </div>
              </div>
              <button type="button" class="btn-close" (click)="closeAddMemberModal()" aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body px-4 py-3">
              <!-- Info banner -->
              <div class="alert alert-info d-flex align-items-start gap-2 py-2 px-3 mb-3" role="alert">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" class="flex-shrink-0 mt-1">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="16" x2="12" y2="12" />
                  <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
                <small>Only users from the
                  <strong>same application and organisation</strong> are shown.
                  Users already in this group are excluded.</small>
              </div>

              <!-- Search input with live suggestions -->
              <div class="mb-3 add-member-search-wrap position-relative">
                <label class="form-label fw-medium mb-1">Search by name or email</label>
                <div class="input-group">
                  <span class="input-group-text bg-white border-end-0">
                    <!-- Spinner while loading -->
                    <span *ngIf="loadingAddMemberSuggestions" class="spinner-border spinner-border-sm text-primary"
                      role="status" aria-hidden="true"></span>
                    <!-- Search icon when idle -->
                    <svg *ngIf="!loadingAddMemberSuggestions" width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke="#6c757d" stroke-width="2.5" stroke-linecap="round">
                      <circle cx="11" cy="11" r="8" />
                      <path d="m21 21-4.35-4.35" />
                    </svg>
                  </span>
                  <input type="text" class="form-control border-start-0 ps-1" [value]="addMemberSearchQuery"
                    (input)="onAddMemberSearchInput($any($event.target).value)" placeholder="Type a name or email…"
                    autocomplete="off" />
                  <!-- Clear button -->
                  <button class="btn btn-outline-secondary border-start-0" *ngIf="addMemberSearchQuery" (click)="
                      addMemberSearchQuery = '';
                      addMemberSuggestions = [];
                      selectedAddMemberUser = null
                    " type="button">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round">
                      <path d="M18 6 6 18M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <!-- Live suggestion dropdown (Bootstrap list-group) -->
                <ul class="list-group shadow-sm add-member-suggestions-list" *ngIf="addMemberSuggestions.length > 0">
                  <li *ngFor="let candidate of addMemberSuggestions"
                    class="list-group-item list-group-item-action d-flex align-items-center gap-3 py-2 px-3"
                    (click)="selectAddMemberCandidate(candidate)" role="button">
                    <!-- Avatar -->
                    <div class="avatar avatar-sm flex-shrink-0" [style.background]="color(candidate.userId)">
                      {{ initials(candidate.displayName) }}
                    </div>
                    <!-- Info -->
                    <div class="flex-grow-1 overflow-hidden">
                      <div class="fw-medium text-truncate">
                        {{ candidate.displayName }}
                      </div>
                      <small class="text-muted text-truncate d-block">{{
                        candidate.email
                        }}</small>
                    </div>
                    <!-- Select indicator -->
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="2"
                      stroke-linecap="round">
                      <path d="m9 18 6-6-6-6" />
                    </svg>
                  </li>
                </ul>

                <!-- Empty state when query present but no results -->
                <div class="add-member-empty-state" *ngIf="
                    addMemberSearchQuery.trim() &&
                    !loadingAddMemberSuggestions &&
                    addMemberSuggestions.length === 0 &&
                    !selectedAddMemberUser
                  ">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#adb5bd" stroke-width="1.5"
                    stroke-linecap="round">
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                  </svg>
                  <p class="mb-0 text-muted">
                    No users found matching
                    <strong>"{{ addMemberSearchQuery }}"</strong>
                  </p>
                  <small class="text-muted">Only users from the same app & org are listed</small>
                </div>
              </div>

              <!-- Selected user preview card -->
              <div class="card border-primary border-opacity-50 bg-primary bg-opacity-10 mb-3"
                *ngIf="selectedAddMemberUser">
                <div class="card-body py-2 px-3 d-flex align-items-center gap-3">
                  <div class="avatar avatar-sm flex-shrink-0" [style.background]="color(selectedAddMemberUser.userId)">
                    {{ initials(selectedAddMemberUser.displayName) }}
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <div class="fw-semibold text-truncate">
                      {{ selectedAddMemberUser.displayName }}
                    </div>
                    <small class="text-muted text-truncate d-block">{{
                      selectedAddMemberUser.email
                      }}</small>
                  </div>
                  <!-- Remove selection -->
                  <button class="btn btn-sm btn-link text-muted p-0" (click)="
                      selectedAddMemberUser = null;
                      addMemberSearchQuery = '';
                      addMemberMessage = ''
                    " title="Remove selection">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round">
                      <path d="M18 6 6 18M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Feedback alert (success / error) -->
              <div *ngIf="addMemberMessage" class="alert py-2 px-3 mb-0 d-flex align-items-center gap-2"
                [class.alert-success]="!addMemberError" [class.alert-danger]="addMemberError" role="alert">
                <!-- Success icon -->
                <svg *ngIf="!addMemberError" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" class="flex-shrink-0">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <!-- Error icon -->
                <svg *ngIf="addMemberError" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2.5" stroke-linecap="round" class="flex-shrink-0">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <small>{{ addMemberMessage }}</small>
              </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer border-top px-4 py-3">
              <button type="button" class="btn btn-outline-secondary btn-sm px-4" (click)="closeAddMemberModal()">
                Close
              </button>
              <button type="button" class="btn btn-primary btn-sm px-4 d-flex align-items-center gap-2"
                (click)="confirmAddMember()" [disabled]="!selectedAddMemberUser || addingMember">
                <!-- Spinner while adding -->
                <span *ngIf="addingMember" class="spinner-border spinner-border-sm" role="status"
                  aria-hidden="true"></span>
                <!-- Person-add icon when idle -->
                <svg *ngIf="!addingMember" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2.5" stroke-linecap="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <line x1="19" y1="8" x2="19" y2="14" />
                  <line x1="22" y1="11" x2="16" y2="11" />
                </svg>
                {{ addingMember ? "Adding…" : "Add to Group" }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Image preview modal -->
      <!-- Image preview modal -->
      <div class="image-modal" *ngIf="previewImageUrl" (click)="closePreview()">
        <div class="modal-content" (click)="$event.stopPropagation()">
          <!-- Topbar -->
          <div class="modal-topbar">
            <span class="modal-filename">{{ previewFileName || "Image" }}</span>
            <div class="modal-actions">
              <!-- Download -->
              <button class="modal-action-btn" (click)="
                  downloadFile(previewImageUrl, previewFileName || 'image')
                " title="Download">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                  stroke-linecap="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </button>
              <button class="modal-action-btn" (click)="closePreview()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                  stroke-linecap="round">
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <img [src]="previewImageUrl" alt="Preview" />
        </div>
      </div>
    </div>
  </div>
  <!-- Leave Model -->
  <div class="leave-modal-fixed" *ngIf="showLeaveGroupModal" (click)="closeLeaveGroupModal()">
    <div class="leave-modal-container" (click)="$event.stopPropagation()">
      <div class="card shadow-lg border-0 rounded-4" style="width: 400px; max-width: 90vw">
        <!-- Header – more bottom margin -->
        <div class="card-header bg-white border-0 pt-4 pb-2 px-4 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-3">
            <div class="bg-danger bg-opacity-10 rounded-circle p-2 text-danger">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </div>
            <h5 class="mb-0 fw-semibold">Leave group</h5>
          </div>
          <button type="button" class="btn-close" (click)="closeLeaveGroupModal()" [disabled]="leavingGroup"></button>
        </div>

        <!-- Body – top and bottom padding increased -->
        <div class="card-body py-3 px-4">
          <p class="mb-2">
            Are you sure you want to leave
            <strong>“{{ selectedRoom?.roomName }}”</strong>?
          </p>
          <p class="text-muted small mb-0">
            You will no longer receive messages from this group.
          </p>
        </div>

        <!-- Footer – top margin and button gap -->
        <div class="card-footer bg-white border-0 pb-4 pt-2 px-4 d-flex justify-content-end gap-3">
          <button class="btn btn-light rounded-pill px-4" (click)="closeLeaveGroupModal()" [disabled]="leavingGroup">
            Cancel
          </button>
          <button class="btn btn-danger rounded-pill px-4 d-flex align-items-center gap-2" (click)="leaveGroup()"
            [disabled]="leavingGroup">
            <span *ngIf="leavingGroup" class="spinner-border spinner-border-sm"></span>
            {{ leavingGroup ? "Leaving…" : "Leave group" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
